import React, { useEffect, useState } from "react";
import Pagetitle from "./component/Pagetitle";
import { Link, useNavigate } from "react-router-dom";
import { useApiStore } from "./hooks/ApiStoreContext";
import { useCart } from "./hooks/CartContext";
import { useAuth } from "./hooks/AuthProvider";

function Viewcart() {
  const apiStore = useApiStore();
  const {userId}=useAuth();
  const {removeFromCartContext} = useCart();
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [totalBill, setTotalBill] = useState(0.0);
  const [subTotal, setSubTotal] = useState(0.0);
  const [totalSavings, setTotalSavings] = useState(0.0);
  const [totalGSTAmount, setTotalGSTAmount] = useState(0.0);
  const [ignoreBindCart, setIgnoreBindCart] = useState(false);

  useEffect(() => {
    window.initSwiper();
    if (!ignoreBindCart) {
      bindCartItems();
      setIgnoreBindCart(true);
    }
    updateSubTotal();
  }, [tableData]);

  const bindCartItems = async () => {
    try {
      let loginUserId = userId;
      if (!loginUserId) {
        navigate("/login");
        return;
      }

      const data = await apiStore.get(`/users/GetCartItems?userId=${Number(loginUserId)}`);
      setTableData(data);
    } catch (error) {
      console.error("Error getting cart:", error);
      if (error.status === 401) {
        navigate("/login");
      }
    }
  };

  const updateSubTotal = () => {
    let bill = 0.0;
    let savings = 0.0;
    let gstAmount = 0.0;
    let sTotal = 0.0;

    tableData.forEach((row) => {
      bill += row.price * row.quantity;
      savings += row.discountAmount * row.quantity;
      gstAmount += row.gstAmountAfterDiscount * row.quantity;
      sTotal += row.total;
    });

    setTotalBill(bill);
    setTotalSavings(savings);
    setTotalGSTAmount(gstAmount);
    setSubTotal(sTotal);
  };

  const handleIncreaseQuantity = (e, id) => {
    e.preventDefault();

    const newData = tableData.map((data) => {
      if (data.cartId !== id) {
        // No change
        return data;
      } else {
        if (data.quantity > -1) {
          return {
            ...data,
            quantity: data.quantity + 1,
            total: data.finalPrice * (data.quantity + 1),
          };
        } else {
          return data;
        }
      }
    });
    // Re-render with the new array
    setTableData(newData);
    const currentRow = newData.find((t) => t.cartId === id);
    handleAddToCart(currentRow.productId, currentRow.quantity);
    //updateSubTotal();
  };

  const handleReduceQuantity = (e, id) => {
    e.preventDefault();

    const newData = tableData.map((data) => {
      if (data.cartId !== id) {
        // No change
        return data;
      } else {
        if (data.quantity > data.minimumOrderQuantity) {
          return {
            ...data,
            quantity: data.quantity - 1,
            total: data.finalPrice * (data.quantity - 1),
          };
        } else {
          return data;
        }
      }
    });
    // Re-render with the new array
    setTableData(newData);
    const currentRow = newData.find((t) => t.cartId === id);
    handleAddToCart(currentRow.productId, currentRow.quantity);
    //updateSubTotal();
  };

  const handleRemove = (e, id) => {
    e.preventDefault();
    let productId = tableData.find((t) => t.cartId === id).productId;
    setTableData(tableData.filter((x) => x.cartId !== id));
    handleAddToCart(productId, 0);
    removeFromCartContext(productId);
  };

  const handleAddToCart = async (productId, qty) => {
    try {
      let loginUserId = userId;
      if (!loginUserId) {
        navigate("/login");
        return;
      }

      await apiStore.post("/users/AddToCart", {
        shoppingCartId: 0,
        productId: productId,
        quantity: qty,
        userId: Number(loginUserId),
      });
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  };

  const handleQuantityChange = (e) => {
    console.log("handle quantity change");
  };

  const handleCheckout = (e) => {
    e.preventDefault();
    if (!tableData.length) {
      alert("No items in cart to checkout");
      return;
    }
    navigate("/check-out");
  };

  return (
    <>
      <Pagetitle title="Shopping Cart" />
      <section className="flat-spacing-11">
        <div className="container">
          <div className="tf-page-cart-wrap">
            <div className="tf-page-cart-item">
              <form>
                <table className="tf-table-page-cart">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Discount</th>
                      <th>GST</th>
                      <th>Quantity</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((item, i) => {
                      return [
                        <tr key={item.cartId} className="tf-cart-item file-delete">
                          <td className="tf-cart-item_product">
                            <a href="product-detail.html" className="img-box">
                              <img src={item.productImageUrl} alt="img-product" />
                            </a>
                            <div className="cart-info">
                              <a href="product-detail.html" className="cart-title link">
                                {item.productName}
                              </a>
                              <div className="cart-meta-variant">{item.productVariant}</div>
                              <span className="remove-cart link remove" style={{ color: "red" }} onClick={(e) => handleRemove(e, item.cartId)}>
                                Remove
                              </span>
                            </div>
                          </td>
                          <td className="tf-cart-item_price" cart-data-title="Price">
                            <div className="cart-price">₹{item.price.toFixed(2)}</div>
                          </td>
                          <td className="tf-cart-item_price" cart-data-title="Discount">
                            <div className="cart-price">{item.discountPercentage ? item.discountPercentage + "%" : ""}</div>
                          </td>
                          <td className="tf-cart-item_price" cart-data-title="GST">
                            <div className="cart-price">{item.gstPercentage ? item.gstPercentage + "%" : ""}</div>
                          </td>
                          <td className="tf-cart-item_quantity" cart-data-title="Quantity">
                            <div className="cart-quantity">
                              <div className="wg-quantity">
                                <span className="btn-quantity minus-btn" onClick={(e) => handleReduceQuantity(e, item.cartId)}>
                                  <svg className="d-inline-block" width="9" height="1" viewBox="0 0 9 1" fill="currentColor">
                                    <path d="M9 1H5.14286H3.85714H0V1.50201e-05H3.85714L5.14286 0L9 1.50201e-05V1Z"></path>
                                  </svg>
                                </span>
                                <input type="text" name="number" value={item.quantity} onChange={handleQuantityChange} />
                                <span className="btn-quantity plus-btn" onClick={(e) => handleIncreaseQuantity(e, item.cartId)}>
                                  <svg className="d-inline-block" width="9" height="9" viewBox="0 0 9 9" fill="currentColor">
                                    <path d="M9 5.14286H5.14286V9H3.85714V5.14286H0V3.85714H3.85714V0H5.14286V3.85714H9V5.14286Z"></path>
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="tf-cart-item_total" cart-data-title="Total">
                            <div className="cart-total">₹{item.total.toFixed(2)}</div>
                          </td>
                        </tr>,
                      ];
                    })}
                  </tbody>
                </table>
                {/* <div className="tf-page-cart-note">
                  <label htmlFor="cart-note">Add Order Note</label>
                  <textarea name="note" id="cart-note" placeholder="How can we help you?"></textarea>
                </div> */}
              </form>
            </div>
            <div className="tf-page-cart-footer">
              <div className="tf-cart-footer-inner">
                <div className="tf-page-cart-checkout">
                  <div className="tf-cart-totals-discounts">
                    <h3>Total Price</h3>
                    <span className="total-value">₹{totalBill.toFixed(2)}</span>
                  </div>
                  <div className="tf-cart-totals-discounts">
                    <h3 style={{ fontStyle: "italic", color: "green", fontSize: "0.9em" }}>Discount</h3>
                    <span className="total-value" style={{ color: "green", fontSize: "0.9em" }}>
                      - ₹{totalSavings.toFixed(2)}
                    </span>
                  </div>
                  <div className="tf-cart-totals-discounts">
                    <h3 style={{ fontStyle: "italic", fontSize: "0.9em" }}>GST</h3>
                    <span className="total-value" style={{ fontSize: "0.9em" }}>
                      + ₹{totalGSTAmount.toFixed(2)}
                    </span>
                  </div>
                  <div className="tf-cart-totals-discounts">
                    <h3>Order Total</h3>
                    <span className="total-value">₹{subTotal.toFixed(2)}</span>
                  </div>
                  <div className="cart-checkout-btn">
                    <button className="tf-btn w-100 btn-fill animate-hover-btn radius-3 justify-content-center" onClick={handleCheckout}>
                      <span>Check out</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Viewcart;
